import { render, staticRenderFns } from "./ImplantStep3.vue?vue&type=template&id=6c9cf20a&scoped=true&"
import script from "./ImplantStep3.vue?vue&type=script&lang=js&"
export * from "./ImplantStep3.vue?vue&type=script&lang=js&"
import style0 from "./ImplantStep3.vue?vue&type=style&index=0&id=6c9cf20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9cf20a",
  null
  
)

export default component.exports